import { FC } from "react"

import { Table, Flex, InputNumber , Select, Typography } from "antd"

import { ColorifiedButton } from "@/components/_Shared/Button/ColorifiedButton"

import { IBulkOrderFuel, IBulkOrderFuelCreate } from "@/types/IBulkOrder"
import { getTransformedFuelDensity, convertFuelAmountToLitres } from "@/types/IFuel"
import { IFuelType } from "@/types/IFuelType"

import { formatNumber, formatFuelAmount, getMoney, formatFuelVolume } from "@/utils/formatNumber"

const { Text } = Typography


export interface BulkOrderFuelTableProps {
  fuels: IBulkOrderFuelCreate[] | undefined
  additionalColumns?: any[]
  fuelTypes: IFuelType[] | undefined
  onChange(guid: string, name: string, value: string): void
}

export const BulkOrderFuelTable: FC<BulkOrderFuelTableProps> = (props) => {
  const { fuels, additionalColumns, fuelTypes, onChange } = props

  const onСhangeInput = (e: any) => {
    if (e.target) {
      onChange(e.target.id, e.target.name,e.target.value)
    }
  }

  const onСhangeSelect = (value: number, options: any) => {
    if (options) {
      onChange(options.id, options.name, options.value)
    }
  }
                  
  const fuelColumns = [
    {
      title: "Тип топлива",
      dataIndex: "fuelType",
      key: "fuelType",
      width: 350,
      render: (_: any, fuel: IBulkOrderFuelCreate) => 
        /*<Select
          placeholder="Тип топлива"
          showSearch          
          defaultValue={fuel.fuelTypeId}
          style={{ width: "100%" }}
          onChange={onСhangeSelect}
          options={fuelTypes?.map((fuelType) => ({
            value: fuelType.id,
            label: fuelType.name,
            id: fuel.guid,
            name: "fuelType"
          }))}
        />,*/
        <Text>{fuel.fuelTypeName}</Text>,
      isVisible: true
    },
    {
      title: "Количество, тн",
      dataIndex: "quantity",
      key: "quantity",
      width: 150,
      render: (_: any, fuel: IBulkOrderFuelCreate) =>
        <InputNumber 
          id={fuel.guid}
          name={"quantity"}
          defaultValue={fuel.quantity}
          min={0}
          style={{ width: "100%" }}
          parser={(value) => value === "" ? value.replace("", "0") as unknown as number : value as unknown as number}
          onChangeCapture={onСhangeInput}
        />,
      isVisible: true
    },
    {
      title: "Цена",
      dataIndex: "offeredPrice",
      key: "offeredPrice",
      render: (_: any, fuel: IBulkOrderFuelCreate) =>
        <InputNumber  
          id={fuel.guid}
          name={"offeredPrice"}
          min={0}
          style={{ width: "100%" }}
          defaultValue={fuel.offeredPrice ? fuel.offeredPrice : undefined}
          placeholder="на дату отгрузки"
          onChangeCapture={onСhangeInput}
        />,
      isVisible: true
    }
  ]

  return (
    <Table
      columns={[...fuelColumns.filter(c => c.isVisible), ...(additionalColumns ?? [])]}
      rowKey={(fuel) => crypto.randomUUID()}
      dataSource={fuels}
      pagination={false}
    />
  )
}